import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-vsr-collage.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "New! Virtual Sales Rep (VSR)";

const VirtualSalesRepFeature = () => (
  <div className="py-10">
    <div className="bg-navy pt-20 pb-10 transform skew-y-6">
      <HeroSection title={title} className="flex-col-reverse md:flex-row text-white -skew-y-6">
        <HeroSection.Content className="w-full md:w-1/2 lg:w-5/12 lg:pr-0">
          <HeroSection.Header className="md:justify-start md:items-start">
            <Heading tag="h2">{title}</Heading>
          </HeroSection.Header>
          <HeroSection.Description className="text-gray-300">
            Capture and qualify leads online 24/7 with the setter that never sleeps. Embed the Enerflo VSR app on your
            website to generate more, higher quality leads effortlessly, without adding headcount.
          </HeroSection.Description>
          <HeroSection.Action className="btn-white md:text-center" href="/features/virtual-sales-rep">
            Learn more about Virtual Sales Rep (VSR)
          </HeroSection.Action>
        </HeroSection.Content>

        <figure className="flex-grow p-3 md:pl-6 w-full xs:w-3/4 sm:w-3/5 md:w-1/2">
          <div className="pl-6 md:pl-0">
            <Image
              src={FigureImage}
              alt="Enerflo VSR: Virtual Sales Rep & Inside Sales in a Box for Solar."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
      </HeroSection>
    </div>
  </div>
);

export default VirtualSalesRepFeature;
